import { createClient } from '@supabase/supabase-js';
import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

const supabaseUrl = process.env.EXPO_PUBLIC_SUPABASE_URL || 'https://your-project.supabase.co';
const supabaseAnonKey = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY || 'your-anon-key';

// Web already persists sessions via the browser's localStorage automatically.
// Native needs an explicit storage adapter or sessions never survive an app restart.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: Platform.OS === 'web'
    ? undefined
    : {
        storage: AsyncStorage,
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: false,
      },
});
